import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getDatapointsConfigSelector } from '../../configurations/selectors'
import { IDataPointsConfig } from '../../configurations/store/configurations.types'
import {
  setUnkAls,
  setUnkCirculation,
  setUnkCpr,
  setUnkDefib,
  setUnkDisc,
  setUnkVent,
  setUnkWitnessed,
} from '../store/ccHpi.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { CcHpiConstants } from '../store/ccHpi.constants'

export function* setDefaultUnknown() {
  const pcrID: string = yield select(getPcrIdSelector)

  const serviceConfig: IDataPointsConfig = yield select(getDatapointsConfigSelector)
  const { DP_CARDIACARREST_TIMES_UNKNOWN } = serviceConfig

  try {
    if (pcrID) {
      const serviceId: string = yield select(getServiceIdSelector)
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      if (!pcrDoc.ccHpiCardiacArrest) {
        yield put(setUnkAls(DP_CARDIACARREST_TIMES_UNKNOWN))
        yield put(setUnkCpr(DP_CARDIACARREST_TIMES_UNKNOWN))
        yield put(setUnkDefib(DP_CARDIACARREST_TIMES_UNKNOWN))
        yield put(setUnkDisc(DP_CARDIACARREST_TIMES_UNKNOWN))
        yield put(setUnkCirculation(DP_CARDIACARREST_TIMES_UNKNOWN))
        yield put(setUnkVent(DP_CARDIACARREST_TIMES_UNKNOWN))
        yield put(setUnkWitnessed(DP_CARDIACARREST_TIMES_UNKNOWN))
      }
    }
  } catch (e) {
    yield put(throwPcrException(`setDefaultUnknown() error: ${e}`))
  }
}

export function* setDefaultUnknownSaga() {
  yield takeLatest([CcHpiConstants.SET_CARDIAC_ARREST_DEFAULTS], performWithMutexHOG, setDefaultUnknown)
}
